import {Helper} from "@nolimitcity/promo-panel/bin/utils/Helper";
import {ASMainGamePickOptions, WINTYPE} from "@nolimitcity/promo-panel/bin/enums/ASEnums";
import {
    ActionSpinOptions,
    ActionSpinSound,
    ASWinData,
    PromoPanelGameConfiguration,
} from "@nolimitcity/promo-panel/bin/interfaces/ASInterfaces";
import {BenjiKIV} from "./BenjiKIV";
import {BenjiKIVGameMode} from "./server/BenjiKIVGameMode";
import {BenjiKIVSound} from "./sound/BenjiKIVSound";
import {BenjiKIVGameAssets} from "./BenjiKIVGameAssets";
import {BenjiKIVGameData} from "./server/BenjiKIVData";
import {TimelineLite} from "gsap";
import {BenjiKIVXBetView} from "./view/general/BenjiKIVXBetView";

export class BenjiKIVPromoPanelConfig implements PromoPanelGameConfiguration {

    constructor() {
    }


    public getActionSpinOptions(): ActionSpinOptions {
        return {
            gameName: "BenjiKIV",
            hasActionSpin: true,
            mainGame: {
                header: () => BenjiKIV.apiPlugin.translations.translate("xBET"),
                options: [
                    {name: "NORMAL", id: 0, image: "NORMAL.png"},
                    {name: "BOOSTED_BET", id: 1, image: "BOOSTED_BET.png"},
                    {name: "BOOSTED_BET_2", id: 2, image: "BOOSTED_BET_2.png"}
                ],
                type: ASMainGamePickOptions.BOOSTED_BET
            },
            graphics: {backgroundTextureName: "BG_Main_Game_For_AS"},
            getParsedData: (response: BenjiKIVGameData, bet: number, prevResponse: BenjiKIVGameData): ASWinData => {
                const parsedData: ASWinData = {
                    totalWin: response.accumulatedRoundWin,
                    totalSpinWinnings: this.getWin(response, bet, prevResponse),
                    wasFeatureBuy: response.wasFeatureBuy,
                    freeSpinTriggeredThisSpin: this.isFreeSpinTriggered(response),
                    isBigWin: this.isBigWin(response),
                    winType: WINTYPE.NORMAL,
                    featureName: this.getFeatureName(response),
                    isRoundComplete: this.isRoundComplete(response),
                    isBonusEnd: this.isBonusEnd(response),
                    isWinCapHit: response.brokeTheBank
                }
                return parsedData;
            }
        };
    }

    public onActionSpinPlaySound(trigger: ActionSpinSound): void {
        if (trigger == ActionSpinSound.WIN) {
            BenjiKIV.soundPlayer.playSound(BenjiKIVSound.AS_WIN);
        } else if (trigger == ActionSpinSound.BIG_WIN) {
            BenjiKIV.soundPlayer.playSound(BenjiKIVSound.AS_WIN_BIG);
        }
    }

    public onPlayBonusInGame(response: BenjiKIVGameData): void {
        BenjiKIV.apiPlugin.slotStates.resetGameStartedAndGameServerFlag();
        BenjiKIV.model.onGame(response);
        BenjiKIV.winWays.hideToggleWinWays();
        BenjiKIV.multiplierCountUp.hideAllMultipliers();
        BenjiKIV.overlayScatterView.deActivateBoostedOverlays(true);
        BenjiKIV.xBetView.stopXBetBlueReelOverlay();
        BenjiKIV.keypadPlugin.setWin(response.accumulatedRoundWin, BenjiKIV.model.showTotalWin, BenjiKIV.isWinBelowStake());
        if (BenjiKIV.apiPlugin.betHandler.betBoost) {
            if (BenjiKIV.apiPlugin.betHandler.betBoost.featureName === BenjiKIVXBetView.BOOST_BET_1) {
                BenjiKIV.xBetView.level01Toggle(false, true);
            } else {
                BenjiKIV.xBetView.level02Toggle(false, true);
            }
            BenjiKIV.xBetView.enableButtons(false);
        } else {
            BenjiKIV.xBetView.turnOffButtonShowForAS();
        }
        const tl: TimelineLite = new TimelineLite();
        tl.add(() => {
            for (let reelIdx: number = 0; reelIdx < BenjiKIV.allReelView.reelModels.length; reelIdx++) {
                const reelView = BenjiKIV.allReelView.reelModels[reelIdx].reelView;
                reelView.reelSymbolsContainer.removeChildren();
                reelView.removeSymFromSymArray();
                const passReels: string[] = JSON.parse(JSON.stringify(BenjiKIV.model.gameData.reels[reelIdx]));
                if (passReels.length > 9) {
                    passReels.shift();
                    passReels.shift();
                    passReels.pop();
                    passReels.pop();
                }
                reelView.init(passReels);
            }
        })
        tl.add(BenjiKIV.overlayScatterView.actionSpinsCreateScatters(response));
        // if (BenjiKIV.normalResult.ENHANCER_RESULT_RUNNER.shouldRun()) {
        //     for (let i: number = 0; i < 5; i++) {
        //         tl.add(BenjiKIV.enhancerView.showResult(i));
        //     }
        // }
        //
        // if (BenjiKIV.winPres.WILD_NUDGE_RUNNER.shouldRun()) {
        //     for (let i: number = 0; i < BenjiKIV.model.wildNudgeReels.length; i++) {
        //         if (BenjiKIV.model.wildNudgeReels[i] !== 0) {
        //             tl.add(BenjiKIV.winPres.WILD_NUDGE_RUNNER.nudgeReel(i, BenjiKIV.allReelView.reelModels[i].reelView.activateStackedReel(), BenjiKIV.model.wildNudgeReels[i]));
        //         }
        //     }
        // }
        //
        // if (BenjiKIV.winPres.MID_NUDGE_RUNNER.shouldRun()) {
        //     for (let i: number = 0; i < BenjiKIV.model.mNudgeReels.length; i++) {
        //         if (BenjiKIV.model.mNudgeReels[i] !== 0) {
        //             tl.add(BenjiKIV.winPres.MID_NUDGE_RUNNER.nudgeReel(i, BenjiKIV.allReelView.reelModels[i].reelView.activateStackedReel(), BenjiKIV.model.mNudgeReels[i]));
        //         }
        //     }
        // }
        BenjiKIV.enhancerView.reset();
        BenjiKIV.enhancerView.asSetEnhancerFeatures();
        tl.progress(1);
        setTimeout(() => {
            BenjiKIV.gameFlowController.start();
        }, 1000);
    }

    private isBigWin(response: BenjiKIVGameData): boolean {
        const win = response.totalSpinWinnings;
        const playedBetValue = response.playedBetValue;
        let winRatio: number = Helper.ceilToDecimals((win / playedBetValue), 2);

        if (response.wasFeatureBuy) {
            const betPrice: number = BenjiKIV.getBuyFeaturePrice()
            winRatio = Helper.ceilToDecimals((win / betPrice), 2);
            return winRatio >= 1;
        }

        return winRatio >= 15;
    }

    private getWin(response: BenjiKIVGameData, bet: number, prevData: BenjiKIVGameData): number {
        return response.totalSpinWinnings;
    }

    private getFeatureName(response: BenjiKIVGameData): string {
        if (response.nextMode == BenjiKIVGameMode.FREESPIN || response.mode == BenjiKIVGameMode.FREESPIN) {
            return "VEGAS$ SPINS";
        }

        if (response.nextMode == BenjiKIVGameMode.SUPER_FREESPIN || response.mode == BenjiKIVGameMode.SUPER_FREESPIN) {
            return "B.I.G. VEGAS$ SPINS";
        }

        return "";
    }

    private isFreeSpinTriggered(response: BenjiKIVGameData): boolean {
        const isFs = (response.mode == BenjiKIVGameMode.NORMAL || response.mode == BenjiKIVGameMode.NORMAL_EXTRA_SPIN) && response.nextMode == BenjiKIVGameMode.FREESPIN;
        const isSfs = (response.mode == BenjiKIVGameMode.NORMAL || response.mode == BenjiKIVGameMode.NORMAL_EXTRA_SPIN) && response.nextMode == BenjiKIVGameMode.SUPER_FREESPIN;
        return isFs || isSfs;
    }

    private isRoundComplete(response: BenjiKIVGameData): boolean {
        return ([BenjiKIVGameMode.NORMAL, BenjiKIVGameMode.FREESPIN, BenjiKIVGameMode.SUPER_FREESPIN].indexOf(response.nextMode) > -1);
    }

    private isBonusEnd(response: BenjiKIVGameData): boolean {
        return (response.mode === BenjiKIVGameMode.FREESPIN || response.mode === BenjiKIVGameMode.SUPER_FREESPIN) && response.nextMode === BenjiKIVGameMode.NORMAL;
    }

}